import React, { useState, memo } from 'react'
import { Link } from 'react-router-dom'
import InputRange from 'react-input-range'
import { useTranslation } from 'react-i18next'

import Dropdown from '../../dropdown'
import { withAppStoreValue, EAppActionTypes, AppStoreDispatchAction } from '../../../store';

interface IAroundMeButtonAppStoreProps {
    dispatch: AppStoreDispatchAction
}

const AroundMeButton = memo((props: IAroundMeButtonAppStoreProps) => {
    const { t, i18n: { languages: [language] } } = useTranslation();
    const [showAroundme, setShowAroundme] = useState(false)
    const [distance, setDistance] = useState(25)
    const [myLocation, setMyLocation] = useState()
    const { dispatch } = props

    const handleResetAroundMe = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault()
        setDistance(25)
    }

    const onShowClick = () => {
        setShowAroundme(false)
        dispatch({ type: EAppActionTypes.SetSelectedCategories, selectedCategories: []})
        dispatch({ type: EAppActionTypes.SetFilter, filter: { hasCoupons: false, categories: [] }})
    }

    return (
        <Dropdown
            buttonTitle={t('Around Me Tooltip')}
            buttonElements={
                <span className="cta">{t('Around Me')}</span>
            }
            onShow={() => {
                if (!myLocation && navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => setMyLocation(position.coords), undefined, {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    })
                }
            }}
            dropdownContent={!myLocation
                ? <p>{t('Share your location is required')}</p>
                : <div className="near-by-picker">
                    <div className="near-by-picker-input">
                        <h6 className={'clearfix'}>{t('Near By')} <small className="fr">Max. {distance} km</small></h6>
                        <InputRange
                            maxValue={99}
                            minValue={1}
                            value={distance}
                            onChange={value => setDistance(value as number)} />
                    </div>
                    <div className="near-by-picker-action clearfix">
                        <a href="/" onClick={handleResetAroundMe} className="cta cta-back cta-small">{t('Reset')}</a>
                        <Link to={{
                            pathname: `/${language}/around-me`,
                            state: {
                                aroundMe: {
                                    distance,
                                    center: {
                                        lat: myLocation && myLocation.latitude,
                                        lng: myLocation && myLocation.longitude
                                    }
                                }
                            }
                        }} className="cta fr cta-small" onClick={onShowClick}>{t('Show')}</Link>
                    </div>
                </div>
            }
            showMenu={showAroundme}
            setShowMenu={setShowAroundme}
        />
    )
})

export default withAppStoreValue<IAroundMeButtonAppStoreProps>(AroundMeButton, ['dispatch'])